import { configureStore } from '@reduxjs/toolkit'
import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER
} from 'redux-persist'

// import storage from 'redux-persist/lib/storage'
import asyncStorage from '@react-native-async-storage/async-storage';
import { websocket } from "./websocket";
import reducer from './mainSlice';
import {notificationsListener} from "./notifications";

// import logger from 'redux-logger'

// import { api } from '../features/api/apiSlice'
// import { serviceLayer } from '../features/api/serviceLayer'
// import stateSanitizerForDevtools from './devtools'

// Can call `combineReducers` yourself if needed
// const rootReducer = combineReducers({
//   posts: postsReducer,
//   users: usersReducer,
//   [api.reducerPath]: api.reducer
// })

const persistConfig = {
    key: 'root',
    // version: 1,
    storage: asyncStorage,
    blacklist: ['temp', 'ws', 'remote']
}

const persistedReducer = persistReducer(persistConfig, reducer)

// STATE ["version", "changed", "init", "users", "images", "icons", "remote", "temp", "legal", "user", "server", "workflows", "tasks", "planned", "contacts", "settings", "deleted", "published", "commit", "wfMap", "notify"]
const store = configureStore({
    // Pass previously created persisted reducer
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => {
        const middleware = getDefaultMiddleware({
            // Pass in a custom `extra` argument to the thunk middleware
            //   thunk: {
            //     extraArgument: { serviceLayer }
            //   },
            // Customize the built-in immutable dev check
            immutableCheck: {
                warnAfter: 64,
                ignoredPaths: ["init", "icons", "legal", "commit", "images"]

            },
            // Customize the built-in serializability dev check
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                ignoredActionPaths: []
            }
        }).prepend(notificationsListener.middleware).concat(websocket)

        // Conditionally add another middleware in dev
        // if (process.env.NODE_ENV !== 'production') {
        //   middleware.push(logger)
        // }

        return middleware
    },
    // Turn off devtools in prod, or pass options in dev
    devTools: true
        // __DEV__ ? {
        //     //   stateSanitizer: stateSanitizerForDevtools
        // }
        //     : false
})

export default store
